<template>
  <b-nav class="w-100">
    <login-dropdown v-model="dropdown" @hideDropdown="hide">
      <template v-slot:activator>
        <b-nav-item
          class="login-desktop-nav text-uppercase"
          :class="{ active: dropdown }"
          @click.stop="dropdown = !dropdown"
          @keydown.esc="hide"
        >
          Log ind
        </b-nav-item>
      </template>
      <LoginForm title="absi log ind" />
    </login-dropdown>

    <b-nav-item
      v-for="(navlink, index) in navLinks"
      :key="index"
      :to="{ name: navlink.name }"
      class="desktop-links nav-link-titel"
    >
      {{ navlink.meta.title | uppercase }}
    </b-nav-item>
  </b-nav>
</template>

<script>
import LoginDropdown from "@/components/authentication/LoginDropdown.vue";
import LoginForm from "@/components/authentication/LoginForm.vue";

export default {
  name: "DesktopNav",
  components: {
    LoginDropdown,
    LoginForm,
  },
  props: {
    navLinks: {
      type: Array,
      required: true,
    },
    errorMsg: {
      type: Boolean,
    },
  },
  data() {
    return {
      dropdown: false,
    };
  },
  watch: {
    errorMsg() {
      if (this.errorMsg) {
        this.dropdown = true;
      }
    },
  },
  methods: {
    hide() {
      this.dropdown = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.router-link-exact-active {
  border-top: 2px solid $primary !important;
}

.active {
  background-color: $rgba-primary-1 !important;
  border-top: solid 2px transparent !important;
}

.nav-item {
  border-right: $border-header;
  font-family: $medium;
}

// The style for the links on desktop
.desktop-links {
  .nav-link {
    border-top: 2px solid white;
    color: $primary;
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    -ms-transition: all 0.5s ease;
    transition: all 0.5s ease;

    &:hover {
      border-color: $rgba-primary-2;
    }
  }
}

// The Login Button
.login-desktop-nav {
  background-color: $primary;
  border-top: solid 2px $primary;

  .nav-link {
    color: white;
  }

  &:hover {
    background-color: $rgba-primary-1;
    border-top: solid 2px transparent;
  }
}
</style>